const PENDING_INVITE_TOKEN_KEY = 'pending_invitation_token';
const LEGACY_PENDING_INVITE_TOKEN_KEY = 'pendingInviteToken';

export function getPendingInviteToken() {
  const token =
    localStorage.getItem(PENDING_INVITE_TOKEN_KEY) ||
    localStorage.getItem(LEGACY_PENDING_INVITE_TOKEN_KEY);

  if (token && !localStorage.getItem(PENDING_INVITE_TOKEN_KEY)) {
    localStorage.setItem(PENDING_INVITE_TOKEN_KEY, token);
  }

  if (localStorage.getItem(LEGACY_PENDING_INVITE_TOKEN_KEY)) {
    localStorage.removeItem(LEGACY_PENDING_INVITE_TOKEN_KEY);
  }

  return token;
}

export function setPendingInviteToken(token) {
  if (!token) {
    clearPendingInviteToken();
    return;
  }

  localStorage.setItem(PENDING_INVITE_TOKEN_KEY, token);
  localStorage.removeItem(LEGACY_PENDING_INVITE_TOKEN_KEY);
}

export function clearPendingInviteToken() {
  localStorage.removeItem(PENDING_INVITE_TOKEN_KEY);
  localStorage.removeItem(LEGACY_PENDING_INVITE_TOKEN_KEY);
}

export { PENDING_INVITE_TOKEN_KEY };
